import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Bookmark18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.50001 0.75H14.5C15.1808 0.75 15.75 1.31917 15.75 2V16C15.75 16.8898 14.7424 17.4888 13.9537 17.1053L9.02001 14.747L4.10995 17.094C3.29256 17.551 2.24654 16.9357 2.25001 15.9983V2C2.25001 1.31917 2.81918 0.75 3.50001 0.75ZM3.75001 2.25V15.6035L8.40692 13.3775C8.7801 13.1652 9.25993 13.1652 9.6331 13.3775L14.25 15.5844V2.25H3.75001Z'
      fill='currentColor'
    />
  </Svg>
);

Bookmark18.displayName = 'Bookmark18';
export default Bookmark18;
